"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRoles = void 0;
function parseRoles(roles) {
    const parsedRoles = JSON.parse(roles);
    const isArray = parsedRoles instanceof Array;
    if (isArray) {
        const normalizedRoles = parsedRoles.map((role) => role.toLowerCase());
        return [...normalizedRoles];
    }
    return { ...parsedRoles };
}
exports.parseRoles = parseRoles;
